"use strict";

module.exports = {
    Control: {
        Textfield: {
            EditableText: require("@gluenetworks/editable_text_control"),
            InputEmail: require("@gluenetworks/input_email_control"),
            InputNumber: require("@gluenetworks/input_number_control"),
            InputPassword: require("@gluenetworks/input_password_control"),
            InputSearch: require("@gluenetworks/input_search_control"),
            InputText: require("@gluenetworks/input_text_control"),
            Textarea: require("@gluenetworks/textarea_control"),
            Tags: require("@gluenetworks/input_text_tags_control"),
        },
        OptionSelection: {
            Single: {
                ButtonGroup: require("@gluenetworks/button_group_control"),
                ComboBox: require("@gluenetworks/combobox").Single,
                InputRadio: require("@gluenetworks/input_radio_control"),
                SelectList: require("@gluenetworks/select_list").Single,
                Icon: {
                    SelectList: require("@gluenetworks/select_list").Icon.Single,
                    ComboBox: require("@gluenetworks/combobox").Icon.Single,
                },
            },
            Multiple: {
                ComboBox: require("@gluenetworks/combobox").Multiple,
                SelectList: require("@gluenetworks/select_list").Multiple,
                FilterableSelectList: require("@gluenetworks/select_list").FilterableMultiple,
                Icon: {
                    SelectList: require("@gluenetworks/select_list").Icon.Multiple,
                    ComboBox: require("@gluenetworks/combobox").Icon.Multiple,
                },
            },
        },
        Action: {
            Button: require("@gluenetworks/button_control"),
            InputFile: require("@gluenetworks/input_file_control"),
        },
        Boolean: {
            InputCheckbox: require("@gluenetworks/input_checkbox_control"),
        },
        Timestamp: {
            DatePicker: require("@gluenetworks/date_time_picker").DatePicker,
            DateTimePicker: require("@gluenetworks/date_time_picker").DateTimePicker,
        },
    },
    Widget: {},
    IconRegistry: require("@gluenetworks/icon_registry").getInstance(),
    IconTypes: {
        "base-icon-gl": require("./src/icons/icontypes/base/BaseIcon"),
        "actionable-icon-gl": require("./src/icons/icontypes/actionable/ActionableIcon"),
        "branding-icon-gl": require("./src/icons/icontypes/branding/BrandingIcon"),
        "toggle-icon-gl": require("./src/icons/icontypes/toggle/ToggleIcon"),
    },
};
